import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'app-button-trail-functions',
    templateUrl: './button-trial-functions.component.html',
    standalone: false
})
export class ButtonTrailFunctionsComponent implements ICellRendererAngularComp {
    viewdetailaction: string = "ViewDetailAction";
    actionButtons: any[] = [];
    params: ICellRendererParams;
    data: any = {};
    buttontext: string = '';
    constructor(
        private translate: TranslateService
    ) { }

    onUserAction(action) {
        this.params.data.userAction = action;
        this.params.node.setData(this.params.data);
        this.params.eGridCell.click();
    }

    initilize(params: ICellRendererParams) {
        if (params && params.data) {
            this.params = params;
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}